/// <reference path="../../setup/_references.ts" />
module nucleus.HideHelpJumpToLinkDirective {
    'use strict';

    export class HideHelpJumpToLinkDirective implements ng.IDirective {
        link: ng.IDirectiveLinkFn;
        linkedElement: ng.IAugmentedJQuery;
        constructor( private $timeout: ng.ITimeoutService ) {
            this.link = ($scope: ng.IScope, $element: ng.IAugmentedJQuery, $attr: ng.IAttributes) => {
                this.$timeout(() => {
                    if (angular.element('#video-library').length === 0 && angular.element('#common-topics').length === 0 ) {
                        angular.element('li[href="help"]').hide();
                        angular.element('#help-widget-title').hide();
                    }
                });
            };
        }
    }

    angular.module('nucleus.HideHelpJumpToLinkDirective', [])
        .directive('hideHelpJumpToLink', ['$timeout', ($timeout: ng.ITimeoutService): ng.IDirective => {
            return new HideHelpJumpToLinkDirective($timeout);
        }]);
}
